module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/156-costa-rica-dfa8e843d7c0a503e373827b2ee0f53c.svg";